import * as React from 'react'

import * as Sentry from '@sentry/browser'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import forms from 'modules/enps/store/collections/forms'
import type EnpsForm from 'modules/enps/store/models/Form'

export function useForm(
  refreshForm: boolean,
  setRefreshForm: (param: boolean) => void,
  canCreateForms = false,
  loadingPolicies = false
): {
  loading: boolean
  form: EnpsForm | undefined
} {
  const [form, setForm] = React.useState<EnpsForm>()

  const { loading } = useAsyncData(async () => {
    if (loadingPolicies) return
    if (!!form || !refreshForm) return

    try {
      await forms.fetch()

      if (canCreateForms && forms.models.length === 0) {
        const createdForm = await forms.setup()
        forms.add(createdForm)
      }

      const loadedForm: EnpsForm | undefined = forms.models[0]

      setForm(loadedForm)
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          canCreateForms,
          loadingPolicies,
          formsCount: forms.models.length,
          context: 'useForm - eNPS form fetch/setup error',
        },
      })
    } finally {
      setRefreshForm(false)
    }
  }, [refreshForm, loadingPolicies, canCreateForms])

  return {
    loading,
    form,
  }
}
